export const graphqlBaseUrl = "";
// export const baseUrl = "https://api-quizapp.funq.in/graphql/trader";
export const baseUrl = process.env.REACT_APP_BACKEND_URL;
